import React, { Component } from 'react';
import { connect } from 'react-redux';
import { createSelector } from 'reselect';
import cn from 'classnames';
import styles from './Region.scss';
import { withRouter } from 'react-router-dom';
import { loadProfile } from 'actions/profile';
import { withTranslation } from 'react-i18next';
import AngleDown from 'react-icons/lib/fa/angle-down';
import RegionPopup from './RegionPopup';
import { setPopUp } from 'actions/environment';
import { gaEvent, trackGA } from 'services/ga'

class Region extends Component {

  setPopUp = () => {
    const { setPopUp, cities, profile } = this.props;

    trackGA(gaEvent.headerButtonsClick({ eventLabel: 'lokaciya', user_id: profile.id }));

    setPopUp(
      <RegionPopup cities={cities} profile={profile} />,
      {
        closeStyleName: 'Default',
        contentStyleName: 'Default',
        closeIcon: 'default'
      }
    );
  }

  render() {
    const { className, profile, cities } = this.props;
    const { user_region } = profile;
    const { country_name, city } = user_region;

    if (cities.length < 2) {
      return (
        <div className={cn(styles.Region, className)}>
          <div className={styles.Text}>
            <span >{`${country_name}, ${city}`}</span>
          </div>
        </div>
      );
    }

    return (
      <div className={cn(styles.Region, className)} onClick={this.setPopUp}>
        <div className={styles.Text}>
          <span >{`${country_name}, ${city}`}</span>
          <AngleDown className={styles.Icon} />
        </div>
      </div>
    );
  }
}

const regionSelector = createSelector(
  state => state.building.cities,
  (cities) => ({
    cities
  })
);

export default Region = withTranslation()(
  connect(
    regionSelector,
    { setPopUp, loadProfile }
  )(
    withRouter(Region)
  )
);



// WEBPACK FOOTER //
// ./src/components/Header/Region/Region.js